import Listing from 'vcomponents/listing/Listing.vue';
import ActivitiesListing from 'vcomponents/pages/activities/ActivitiesListing.vue';
import ActivitiesReport from 'vcomponents/activities/ActivitiesReport.vue';
import ActivitiesReportListing from 'vcomponents/activities/reports/ActivitesReportListing.vue';
import ActivitiesReportChart from 'vcomponents/activities/reports/ActivitesReportChart.vue';
import ActivityListingRoutingResolver from 'api/routing/listings/ActivityListingRoutingResolver';

/**
 * Front route declaration, with their associated component
 * @see {@link https://router.vuejs.org/guide/essentials/named-routes.html|Vue Router Named Route}
 */

export default [
    // listing
    {
        path: '/activities/all',
        name: 'activities.crm.listing.all',
        component: ActivitiesListing,
        meta: {
            title: window.i18n.__("Liste d'activités"),
        },
    },
    // report listing
    {
        path: '/activities',
        name: 'activities.crm.listing',
        component: Listing,
        meta: {
            title: window.i18n.__("Liste d'activité"),
            menuId: 'reports',
        },
        beforeEnter: (to, from, next) => {
            const listingResolver = new ActivityListingRoutingResolver();
            listingResolver.feed(to);
            next();
        },
        props: true,
    },
    {
        path: '/activities/report',
        name: 'activities.report',
        component: ActivitiesReport,
        meta: {
            menuId: 'activity-reports',
        },
        props: true,
        children: [
            {
                path: ':type(all|staff)/listing',
                name: 'activities.report.listing',
                component: ActivitiesReportListing,
            },
            {
                path: ':type(all|staff|label)/chart',
                name: 'activities.report.chart',
                component: ActivitiesReportChart,
            },
            { path: '', redirect: 'all/chart' },
        ],
    },
];
